// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5RY1q","main-image":"Header_main-image__9y0LI"};